import type { FC, RefObject } from 'react';
import { useCallback, useRef } from 'react';
import clsx from 'clsx';

import type { IUser } from 'store/declare';

import { videoManager } from 'manager/videoManager';

import MediaContent from '../MediaContent';
import styles from './styles.module.scss';
import UserData from './UserData';

interface IProps extends IUser {
    className?: string;
    /** Пользователь является текущим пользователем */
    isCurrentUser: boolean;
    /** Условие для отрисовки видео */
    renderVideo: boolean;
}

const User: FC<IProps> = ({
    avatar,
    className,
    id,
    isCameraEnabled,
    isCurrentUser,
    isMuted,
    isSharing,
    isTalking,
    name,
    position,
    renderVideo,
    type,
}) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const drawVideoFunction = useCallback(() => {
        if (renderVideo) {
            videoManager.getVideoManagerByUserId(id)?.draw();
        }
    }, [renderVideo, id]);

    return (
        <div className={clsx(styles.wrapper, className, { [styles.wrapperIsTalking]: isTalking })} ref={cardRef}>
            <MediaContent
                location='user'
                name={name}
                avatar={avatar}
                id={id}
                isCameraEnabled={isCameraEnabled}
                drawVideoFunction={drawVideoFunction}
                type={type}
            />
            <UserData
                cardRef={cardRef as RefObject<HTMLDivElement>}
                name={name}
                type={type}
                isSharing={isSharing}
                isCurrentUser={isCurrentUser}
                isMuted={isMuted}
                position={position}
            />
        </div>
    );
};

export default User;
